import React, { useState, useEffect } from 'react';
import { getTranslations } from '../../services/languageUtils';

function Footer() {
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    const loadTranslations = async () => {
      const trans = await getTranslations((localStorage.getItem('language') || 'pt'));
      setTranslations(trans);
    };
    loadTranslations();
  }, []);

  return (
    <section className="FooterComponent" id="FooterComponent">
      <div className="FooterImg">
        <img src={require("../../assets/imgs/banco-central-do-brasil-logo-3.png")} alt={translations.central_bank} className="iconHigherImage" />
      </div>
      <div className="FooterText">
        <b>{translations.authorized_foreign_exchange_correspondent}</b><br/>
        {translations.we_follow_all_rules}
      </div>
    </section>
  );
}

export default Footer;
